import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useLocation, useRoutes, matchPath } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

const PAGE_TITLE_BY_PATH: Array<{ path: string; title: string }> = [
  { path: "/", title: "Đăng nhập" },
  { path: "/forgot-password", title: "Quên mật khẩu" },
  { path: "/receiving", title: "Chọn kho" },
  { path: "/warehouse-ops/putaway", title: "Đưa hàng vào vị trí" },
  { path: "/warehouse-ops/pick", title: "Lấy hàng để xuất" },
  { path: "/warehouse-ops/relocate", title: "Luân chuyển nội bộ" },
  { path: "*", title: "Không tìm thấy trang" },
];

function resolvePageTitle(pathname: string): string {
  const matched = PAGE_TITLE_BY_PATH.find(({ path }) => matchPath({ path, end: true }, pathname));
  const pageTitle = matched?.title ?? "SMT App";

  return `${pageTitle} | Dalat Hasfarm`;
}

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  }, [navigate]);

  useEffect(() => {
    document.title = resolvePageTitle(location.pathname);
  }, [location.pathname]);

  return element;
}
